import React from 'react';
import PropTypes from 'prop-types';
import ChatBox from './chatBox';
import Confirm from '../../../../components/confirm';
import AddNew from '../../../../components/comments/addNew';

const Chat = ({
  t,
  chatId,
  hasMore,
  messages,
  onSubmit,
  loadMore,
  upload_name,
  showConfirm,
  hideConfirm,
  messageToDel,
  messageToEdit,
  searchMessage,
  chatHasLoaded,
  addNewMessage,
  onRemoveCallback,
  setRemoveMessage,
  editMessageSubmit,
  unread_count,
  readMessage,
  onScrollChat,
  ...props
}) => (
  <React.Fragment>
    <Confirm
      show={showConfirm}
      cancelCallback={hideConfirm}
      successCallback={onRemoveCallback}
    />
    <div className="msgleftw">
      {chatId !== -1 ?
        <div>
          <ChatBox
            chatId={chatId}
            searchMessage={searchMessage}
            messages={messages}
            unread_count={unread_count}
            onSubmit={onSubmit}
            hasMore={chatHasLoaded ? hasMore : false}
            loadMore={loadMore}
            messageToDel={messageToDel}
            setRemoveMessage={setRemoveMessage}
            chatHasLoaded={chatHasLoaded}
            readMessage={readMessage}
            onScrollChat={onScrollChat}
            upload_name={upload_name}
            {...props}
          />
          {chatHasLoaded && <AddNew
            attach
            defaultValue={messageToEdit}
            submitDefault={editMessageSubmit}
            upload_name={upload_name}
            onSubmit={addNewMessage}
            setMessageToEdit={props.setMessageToEdit}
            placeholder={t('Start typing')}
          />}
        </div> : <div>{t('Please select chat to view')}</div>}
    </div>

  </React.Fragment>
);

Chat.propTypes = {
  sendMessage: PropTypes.func,
  t: PropTypes.func.isRequired,
  searchMessage: PropTypes.object,
  loadMore: PropTypes.func.isRequired,
  enterMessage: PropTypes.func.isRequired,
  addNewMessage: PropTypes.func.isRequired,
  setRemoveMessage: PropTypes.func.isRequired,
  editMessageSubmit: PropTypes.func.isRequired,
};

export default Chat;



// WEBPACK FOOTER //
// ./src/views/modules/messages/chat/Chat.jsx